import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberResourceEdit',
  data: function data() {
    return {
      title: '',
      form: {
        formMemberUserName: null,
        toMemberUserName: null
      },
      rules: {
        formMemberUserName: [{
          required: true,
          message: '请输入资源ID',
          trigger: 'blur'
        }],
        toMemberUserName: [{
          required: true,
          message: '请输入资源信息',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form = {
        formMemberUserName: null,
        toMemberUserName: null
      };
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.resourceId = data.resourceId;
      this.form.info = data.info;
    },
    saveApi: function saveApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.SYNC_MEMBER_TO_MEMBER_RESOURCE(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    save: function save() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$confirm('请确认是否需要同步数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.saveApi();
          }).catch(function () {
            _this2.$message({
              type: 'info',
              message: '已取消修改'
            });
          });
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};